import type { ScreenerSource } from './statsig';

export function getScreenerSource(): ScreenerSource {
  if (typeof window === 'undefined') return 'unknown';

  try {
    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get('utm_source');
    const source = params.get('source');

    if (utmSource === 'email' || source === 'email') {
      return 'email';
    }

    if (utmSource || source) {
      return 'direct';
    }

    if (document.referrer && document.referrer.length > 0) {
      return 'direct';
    }

    return 'direct';
  } catch (error: unknown) {
    return 'unknown';
  }
}
